.kq{font-family:inherit;}